export default {"src":"/_next/static/media/trustpilot-2.2caae084.svg","height":2378,"width":2500,"blurWidth":0,"blurHeight":0};